/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  DropInAnalyticsResponse,
  EntityType,
  PlatformAnalyticsResponse,
  TimeFilter,
  TrackPlatformEventRequest,
  TrackRouteArrivalRequest,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    DropInAnalyticsResponseFromJSON,
    DropInAnalyticsResponseToJSON,
    EntityTypeFromJSON,
    EntityTypeToJSON,
    PlatformAnalyticsResponseFromJSON,
    PlatformAnalyticsResponseToJSON,
    TimeFilterFromJSON,
    TimeFilterToJSON,
    TrackPlatformEventRequestFromJSON,
    TrackPlatformEventRequestToJSON,
    TrackRouteArrivalRequestFromJSON,
    TrackRouteArrivalRequestToJSON,
} from '../models/index';

export interface CreateTrackRequest {
    trackPlatformEventRequest: TrackPlatformEventRequest;
}

export interface CreateTrackArrivalRequest {
    trackRouteArrivalRequest: TrackRouteArrivalRequest;
}

export interface GetAdminDropInAnalyticsRequest {
    timeFilter?: TimeFilter;
    startDate?: string;
    endDate?: string;
}

export interface GetAdminPlatformAnalyticsRequest {
    entityType?: EntityType;
    timeFilter?: TimeFilter;
    startDate?: string;
    endDate?: string;
}

/**
 * AnalyticsApi - interface
 * 
 * @export
 * @interface AnalyticsApiInterface
 */
export interface AnalyticsApiInterface {
    /**
     * Track a platform event across any surface. Fire-and-forget from the frontend.
     * @param {TrackPlatformEventRequest} trackPlatformEventRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApiInterface
     */
    createTrackRaw(requestParameters: CreateTrackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Track a platform event across any surface. Fire-and-forget from the frontend.
     */
    createTrack(requestParameters: CreateTrackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Record that a user arrived on a route. Fire-and-forget; writes to BigQuery only.
     * @param {TrackRouteArrivalRequest} trackRouteArrivalRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApiInterface
     */
    createTrackArrivalRaw(requestParameters: CreateTrackArrivalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Record that a user arrived on a route. Fire-and-forget; writes to BigQuery only.
     */
    createTrackArrival(requestParameters: CreateTrackArrivalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Drop-In engagement + watch-time analytics
     * @param {TimeFilter} [timeFilter] Time window. Defaults to \&#39;month\&#39;.
     * @param {string} [startDate] Required when timeFilter is \&#39;custom\&#39; (YYYY-MM-DD)
     * @param {string} [endDate] Required when timeFilter is \&#39;custom\&#39; (YYYY-MM-DD)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApiInterface
     */
    getAdminDropInAnalyticsRaw(requestParameters: GetAdminDropInAnalyticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropInAnalyticsResponse>>;

    /**
     * Drop-In engagement + watch-time analytics
     */
    getAdminDropInAnalytics(requestParameters: GetAdminDropInAnalyticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropInAnalyticsResponse>;

    /**
     * 
     * @summary Platform-wide analytics across all entity types
     * @param {EntityType} [entityType] Filter to a specific entity type. Omit for all types.
     * @param {TimeFilter} [timeFilter] Time window. Defaults to \&#39;month\&#39;.
     * @param {string} [startDate] Required when timeFilter is \&#39;custom\&#39; (YYYY-MM-DD)
     * @param {string} [endDate] Required when timeFilter is \&#39;custom\&#39; (YYYY-MM-DD)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApiInterface
     */
    getAdminPlatformAnalyticsRaw(requestParameters: GetAdminPlatformAnalyticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlatformAnalyticsResponse>>;

    /**
     * Platform-wide analytics across all entity types
     */
    getAdminPlatformAnalytics(requestParameters: GetAdminPlatformAnalyticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlatformAnalyticsResponse>;

}

/**
 * 
 */
export class AnalyticsApi extends runtime.BaseAPI implements AnalyticsApiInterface {

    /**
     * Track a platform event across any surface. Fire-and-forget from the frontend.
     */
    async createTrackRaw(requestParameters: CreateTrackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['trackPlatformEventRequest'] == null) {
            throw new runtime.RequiredError(
                'trackPlatformEventRequest',
                'Required parameter "trackPlatformEventRequest" was null or undefined when calling createTrack().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/track`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TrackPlatformEventRequestToJSON(requestParameters['trackPlatformEventRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Track a platform event across any surface. Fire-and-forget from the frontend.
     */
    async createTrack(requestParameters: CreateTrackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createTrackRaw(requestParameters, initOverrides);
    }

    /**
     * Record that a user arrived on a route. Fire-and-forget; writes to BigQuery only.
     */
    async createTrackArrivalRaw(requestParameters: CreateTrackArrivalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['trackRouteArrivalRequest'] == null) {
            throw new runtime.RequiredError(
                'trackRouteArrivalRequest',
                'Required parameter "trackRouteArrivalRequest" was null or undefined when calling createTrackArrival().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/track/arrival`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TrackRouteArrivalRequestToJSON(requestParameters['trackRouteArrivalRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Record that a user arrived on a route. Fire-and-forget; writes to BigQuery only.
     */
    async createTrackArrival(requestParameters: CreateTrackArrivalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createTrackArrivalRaw(requestParameters, initOverrides);
    }

    /**
     * Drop-In engagement + watch-time analytics
     */
    async getAdminDropInAnalyticsRaw(requestParameters: GetAdminDropInAnalyticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropInAnalyticsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/drop-in-analytics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropInAnalyticsResponseFromJSON(jsonValue));
    }

    /**
     * Drop-In engagement + watch-time analytics
     */
    async getAdminDropInAnalytics(requestParameters: GetAdminDropInAnalyticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropInAnalyticsResponse> {
        const response = await this.getAdminDropInAnalyticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Platform-wide analytics across all entity types
     */
    async getAdminPlatformAnalyticsRaw(requestParameters: GetAdminPlatformAnalyticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlatformAnalyticsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/platform-analytics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlatformAnalyticsResponseFromJSON(jsonValue));
    }

    /**
     * Platform-wide analytics across all entity types
     */
    async getAdminPlatformAnalytics(requestParameters: GetAdminPlatformAnalyticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlatformAnalyticsResponse> {
        const response = await this.getAdminPlatformAnalyticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
